import { CloseOutlined, EditOutlined } from "@ant-design/icons";
import { Button, DatePicker, Form, Input, Radio } from "antd";
import moment from "moment";
import React, { memo, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import profile from "../../services/profile";
import { setTitlePage } from "../../utils/helper";
import { isPhoneNumber, isRequired } from "../fields/validator";
import {
  getUserInfo,
  resetUpdateStatus,
  selectProfile,
  updateUserInfo,
} from "./../../redux/reducers/slice/profile/index";
import { isEmail } from "./../fields/validator";
import AddressModal from "./addressModal";
import "./style.scss";

const ProfileInformation = memo((props: any) => {
  const [isNotEdit, setIsNotEdit] = useState(true);
  const { t } = useTranslation();
  const profileSlice = useSelector(selectProfile);
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [initalValues, setInitalValues] = useState<any>(null);
  const [avatar, setAvatar] = useState("");

  const [isShowMessage, setIsShowMessage] = useState(false);
  const [visibleAddressModal, setVisibleAddressModal] = useState(false);

  useEffect(() => {
    if (!initalValues) {
      setLoading(true);

      profile.profileGetInfo((data, err) => {
        if (data) {
          setTitlePage(data.full_name);
          setInitalValues({
            lastName: data?.last_name,
            firstName: data?.first_name,
            phoneNumber: data?.phone_number,
            email: data?.email,
            identityNumber: data?.identity_number,
            birthDay: data?.birthday !== null && moment(data?.birthday),
            gender: data?.gender !== null ? data?.gender : 3,
          });

          setAvatar(data?.avatar);
          setLoading(false);
        }
      });
    }
  }, []);

  useEffect(() => {
    if (!profileSlice.loading && profileSlice.isUpdatted) {
      dispatch(resetUpdateStatus());
      dispatch(getUserInfo());
      setIsNotEdit(true);
      setIsShowMessage(true);
    }
  }, [profileSlice.isUpdatted]);

  const handleEdit = () => {
    if (isNotEdit) {
      setIsNotEdit(false);
    } else {
      form.resetFields();
      setIsNotEdit(true);
    }
  };

  const handleSubmit = async (values: any) => {
    setInitalValues(values);

    const query = {
      first_name: values.firstName,
      last_name: values.lastName,
      identity_number: values.identityNumber,
      gender: values.gender,
      birthday: new Date(values.birthDay),
      email: values.email,
      avatar: avatar,
      // address: values.address,
    };
    await dispatch(await updateUserInfo(query));
  };

  const openAddressModal = () => setVisibleAddressModal(true);
  const closeAddressModal = () => setVisibleAddressModal(false);

  return (
    <>
      <div className="component-container">
        <li className="sub-title kd-name-title-component">
          {t("user_information")}
        </li>

        <div style={{ display: "flex", justifyContent: "center" }}>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "flex-end",
            }}>
            <Button onClick={handleEdit} danger={!isNotEdit}>
              {isNotEdit ? <EditOutlined /> : <CloseOutlined />}
            </Button>
          </div>
        </div>

        {!loading && (
          <Form
            form={form}
            className="kd-info-form-content center"
            size="large"
            name="profileForm"
            labelCol={{ span: 10 }}
            labelAlign="left"
            initialValues={initalValues || {}}
            onFinish={(values) => handleSubmit(values)}>
            <Form.Item
              className="kd-info-form-item"
              name="lastName"
              rules={[isRequired]}
              label={t("field_last_name")}>
              <Input readOnly={isNotEdit} className="input" />
            </Form.Item>

            <Form.Item
              className="kd-info-form-item"
              name="firstName"
              rules={[isRequired]}
              label={t("field_first_name")}>
              <Input readOnly={isNotEdit} className="input" />
            </Form.Item>

            <Form.Item
              className="kd-info-form-item"
              name="phoneNumber"
              rules={[isRequired, isPhoneNumber]}
              label={t("field_phone_number")}>
              <Input readOnly className="input" />
            </Form.Item>

            <Form.Item
              className="kd-info-form-item"
              name="email"
              rules={[isRequired, isEmail]}
              label={t("field_email")}>
              <Input readOnly={isNotEdit} className="input" />
            </Form.Item>

            <Form.Item
              className="kd-info-form-item"
              name="identityNumber"
              label={t("field_identity_number")}>
              <Input readOnly={isNotEdit} className="input" />
            </Form.Item>

            <Form.Item
              className="kd-info-form-item"
              name="birthDay"
              label={t("field_birthday")}>
              <DatePicker
                className="datePicker"
                placeholder="DD/MM/YYYY"
                // aria-readonly={isNotEdit}
                format={["DD/MM/YYYY"]}
                disabled={isNotEdit}
              />
            </Form.Item>

            <Form.Item
              className="kd-info-form-item"
              name="gender"
              label={t("field_gender")}>
              <Radio.Group disabled={isNotEdit}>
                <Radio value={1}>{t("field_gender_male")}</Radio>
                <Radio value={2}>{t("field_gender_female")}</Radio>
                <Radio value={3}>{t("field_gender_others")}</Radio>
              </Radio.Group>
            </Form.Item>

            <Form.Item
              className="kd-info-form-item"
              // name="address.full_address"
              label={t("address")}>
              <Input
                onClick={openAddressModal}
                value={profileSlice.userInfo?.address?.full_address}
                readOnly={true}
                className="input"
                addonAfter={<a onClick={openAddressModal}>Sửa</a>}
              />
            </Form.Item>

            {isShowMessage && (
              <span className="message">{profileSlice.message}</span>
            )}

            <Form.Item noStyle>
              <Button
                disabled={isNotEdit}
                className="kd-info-form-button"
                type="primary"
                htmlType="submit"
                loading={profileSlice.loading}>
                {t("btn_save")}
              </Button>
            </Form.Item>
          </Form>
        )}
      </div>
      {/* {visibleAddressModal && ( */}
      <AddressModal
        visible={visibleAddressModal}
        closeModal={closeAddressModal}
      />
      {/* )} */}
    </>
  );
});

export default ProfileInformation;
